import { render, staticRenderFns } from "./ApprovalFlow.vue?vue&type=template&id=945c4e02"
import script from "./ApprovalFlow.vue?vue&type=script&lang=js"
export * from "./ApprovalFlow.vue?vue&type=script&lang=js"
import style0 from "./ApprovalFlow.vue?vue&type=style&index=0&id=945c4e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports